import api from "@/services/api";

/**
 * @description Servicio para el módulo de contratos médicos.
 * Gestiona contratos entre la obra social y prestadores,
 * incluyendo prestaciones con historial de precios.
 */
const medicalContractService = {};
const endpoint = "/medical-contracts";

/** @description Lista contratos con filtros opcionales */
medicalContractService.query = (params) =>
  api.get(endpoint, { params }).then((r) => r.data);

/** @description Obtiene un contrato por ID */
medicalContractService.getById = (id) =>
  api.get(`${endpoint}/${id}`).then((r) => r.data);

/** @description Crea un nuevo contrato */
medicalContractService.create = (data) =>
  api.post(endpoint, data).then((r) => r.data);

/** @description Actualiza un contrato */
medicalContractService.update = (id, data) =>
  api.put(`${endpoint}/${id}`, data).then((r) => r.data);

/** @description Elimina un contrato en borrador */
medicalContractService.remove = (id) => api.delete(`${endpoint}/${id}`);

/** @description Lista prestaciones de un contrato */
medicalContractService.getItems = (contractId, params) =>
  api.get(`${endpoint}/${contractId}/items`, { params }).then((r) => r.data);

/** @description Agrega o actualiza una prestación en el contrato */
medicalContractService.upsertItem = (contractId, data) =>
  api.post(`${endpoint}/${contractId}/items`, data).then((r) => r.data);

/** @description Actualiza isEnabled de una prestación */
medicalContractService.updateItem = (contractId, itemId, data) =>
  api
    .put(`${endpoint}/${contractId}/items/${itemId}`, data)
    .then((r) => r.data);

/** @description Agrega un precio al historial de una prestación */
medicalContractService.addPrice = (contractId, itemId, data) =>
  api
    .post(`${endpoint}/${contractId}/items/${itemId}/prices`, data)
    .then((r) => r.data);

/** @description Elimina una prestación del contrato */
medicalContractService.removeItem = (contractId, itemId) =>
  api.delete(`${endpoint}/${contractId}/items/${itemId}`);

export default medicalContractService;
